import React, {useMemo} from 'react';
import {useDropzone} from 'react-dropzone';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const focusedStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

export default function Dropzone(props) {

    var accept:any
    if(!props.accept){
      accept = {
        'image/gif': [] , 
        'image/jpeg': [],
        'application/pdf': [],
        'image/png': [], 
        'application/msword': [], 
        'application/vnd': [],
        'application/vnd.ms-excel': [],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document':[],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':[], 
        'image/tiff': [], 
        'text/plain': [], 
        'text/csv': []
      }
    } else {
      accept = props.accept
    }
    if(typeof(accept) === 'string') {
      const tps = accept.split(',');

      let ac = {}
      tps.forEach((tp) => {
        ac[tp] = []
      })
      accept = ac
    }
  
  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({accept: accept, onDrop: props.onDrop, multiple: props.multiple||false, maxSize: props.maxSize, minSize: props.minSize});

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isFocused,
    isDragAccept,
    isDragReject
  ]);

  var children:any = null
  if(typeof(props.children) === 'function'){
    children = props.children({
      getRootProps, 
      getInputProps, 
      isFocused, 
      isDragAccept, 
      isDragReject
    })
  } else {
    children = props.children
  }
  
  return (
    <div className="container">
      <div {...getRootProps({tabIndex: -1, className: 'dropzone'})}>
        <input {...getInputProps()} />
        {children}
     </div>
    </div>
  );
}
